<template>
  <div class="lhsx">
    <div style="padding: 20px 0px 30px 20px;">
      <img src="./logo.png" width="40%" height="30%"  alt="" ref="topLogo"/>
    </div>
    <div style="text-align: center;">
      <img src="./txgg_top.png" width="82%" height="40%" alt="" ref="topLogo"/>
    </div>
    <div id="form" v-if="!showSuccess">
      <input type="text" class="name" placeholder="请输入真实姓名" v-model="formData.clientName"/>
      <input type="tel" class="clientMobile" placeholder="请输入手机号码" maxlength="11" v-model="formData.clientMobile" />
      <input type="tel" class="code" placeholder="请输入验证码" v-model="formData.code" maxlength="6"/>
      <button class="send" :class="{ disable: this.verifyMsg !== '获取验证码'}" @click="sendCode">{{ verifyMsg }}</button>
      <div class="ystk">
        <van-checkbox icon-size="14px" v-model="checked" checked-color	="#ffc500"><span>已阅读并同意</span></van-checkbox><span @click="ystkShow">《个人信息与隐私保护条款》</span>
      </div>
      <div class="coloryellow">
        提交成功后，工作人员会尽快与您联系。
      </div>
      <div class="btn" @click="submit()">
        <img src="./1-5.png" alt="" height="40px">
      </div>
    </div>
    <img id="isSuccess" v-if="showSuccess" style="margin:20px 0 30px 0 ;" src="./2.png" width="100%" height="40%"
      alt="" />
    <img src="./txgg_zbfl.png" width="100%" height="82%" alt="" />
    <!-- 添加微信 -->
    <div class="topdiv wechatImg">
      <img src="./button.png" width="88%" height="100%" alt="" @click="showWechatOverlayHandle" />
    </div>
    <!--  -->
    <img src="./txgg_khzb.png" width="100%" height="82%" alt="" />
    <img src="./4.png" width="100%" height="54%" style="padsding: 20px 0;" alt="" />
    <div class="topdiv" v-if="!showSuccess" @click="backTop()">
      <!-- <button class="backtop" ></button> -->
      <img src="./1-5.png" alt="" height="40px">
    </div>
    <img src="./5-1.png" width="100%" height="3%" alt="" />
    <alert :showModal.sync="showAlert">{{ alertMessage }}</alert>
    <van-overlay :show="showOverlay" :lock-scroll="false" @click="showOverlay = false">
      <div class="wrapper" @click.stop>
        <ystk @close="close"/>
      </div>
    </van-overlay>
    <van-overlay :show="showWechatOverlay" :lock-scroll="false" @click="showWechatOverlay = false">
      <div class="wechatWrapper" @click.stop>
        <img src="./wechat.png" width="80%" height="80%" alt="">
        <div style="margin: 10px; color: #ffffff; text-align: center;">长按识别二维码或保存图片使用微信扫码关注</div>
        <img src="./close.png" width="50px" height="50px" alt="" @click="closeWechatOverlayHandle">
      </div>
    </van-overlay>
  </div>
</template>


<script>
  /* eslint-disable */
  import ajax from "@/common/ajax/ajax";
  import alert from "@/components/alert/alert";
  import ystk from "@/page/bdyxgg/ystk"
  import { Toast } from 'vant'

  window._agl = window._agl || [];
  (function () {
  _agl.push(
  ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
  );
  (function () {
  var agl = document.createElement('script');
  agl.type = 'text/javascript';
  agl.async = true;
  agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(agl, s);
  })();
  })();

  export default {
    data() {
      return {
        formData: {
          channel: "0",
          clientName: "",
          clientMobile: "",
          code: "",
        },
        checked: false,
        showAlert: false,
        alertMessage: "",
        verifyMsg: "获取验证码",
        wait: 30,
        showSuccess: false,
        showOverlay: false,
        showWechatOverlay: false,
        params: [],
        urlParams: {},
      };
    },
    components: { alert, ystk  },
    mounted() {
      this.urlParams = this.utils.splitUrlParam()
      console.log(this.urlParams, 'urlParams');
    },
    methods: {
      sendCode() {
        if (this.verifyMsg !== '获取验证码') {
          this.alertMessage = '验证码请求太快请稍等'
          this.showAlert = true
          return
        }
        if (!this.formData.clientName) {
          this.alertMessage = "请输入真实姓名";
          this.showAlert = true;
          return;
        }

        var reg_tel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; //11位手机号码正则
        if (!reg_tel.test(this.formData.clientMobile)) {
          this.alertMessage = "请输入正确的手机号码";
          this.showAlert = true;
          return;
        }
        let senddata = {
          mobile: $.trim(this.formData.clientMobile),
          // 修改标记
          type: 1003,
        };

        ajax.sendCodeLhsx(senddata).then((data) => {
          let vm = this
          function time() {
            if (vm.wait === 0) {
              vm.verifyMsg = '获取验证码'
              vm.wait = 30
            } else {
              vm.verifyMsg = vm.wait + '秒后重新发送'
              vm.wait--
              setTimeout(function () {
                time()
              }, 1000)
            }
          }

          time()
          let str = data.data.resultMessage;
        }).catch((err) => {
          this.alertMessage = "获取验证码失败"
          this.showAlert = true
        })
      },
      submit() {
        if (!this.formData.clientName) {
          this.alertMessage = "请输入真实姓名";
          this.showAlert = true;
          return;
        }
        var reg_tel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; //11位手机号码正则
        if (!reg_tel.test(this.formData.clientMobile)) {
          this.alertMessage = "请输入正确的手机号码";
          this.showAlert = true;
          return;
        }
        if (!this.formData.code) {
          this.alertMessage = "验证码不能为空";
          this.showAlert = true;
          return;
        }
        if(!this.checked) {
          this.alertMessage = "请勾选同意后再提交";
          this.showAlert = true;
          return;
        }
        let key = "907b067cd20ff4d0e7b928b0a1029b2a";
        this.$set(this.formData, 'proID', this.urlParams.proID)
        console.log(this.formData, 'formData');
        let senddata = this.utils.encrypt(JSON.stringify(this.formData), key);
        let action_time = Date.parse(new Date()).toString().substr(0,10);//精确到秒

        let searchParams = location.search.replace('?', '').split('&')
        let searchObj = {}
        searchParams.length >0 && searchParams.forEach(item => {
          let arr = item.split('=')
          searchObj[arr[0]] = arr[1]
        })
        Toast.loading({
          forbidClick: true,
          duration: 0,
          mask: false
        })
        ajax.loginLhsx(senddata).then((data) => {
          Toast.clear()
          if (data.data.resultStatus == 0) {
            if (data.data.data.needBack == '1' && this.urlParams.HC == 'Y') {
              console.log('走进来了--------------');
              // 需要调用
              window._agl && window._agl.push(['track', ['success', {t: 3}]])
            }
            this.showSuccess = true
           
          } else {
            this.alertMessage = data.data.resultMessage
            this.showAlert = true
          }
        }).catch((err) => {
          Toast.clear()
          this.alertMessage = "申请失败"
          this.showAlert = true
        })
      },
      backTop() {
        document.body.scrollTop = this.$refs.topLogo.scrollHeight + 20
        document.documentElement.scrollTop = this.$refs.topLogo.scrollHeight + 20
      },
      ystkShow() {
        this.showOverlay = true
      },
      close() {
        this.showOverlay = false
      },
      showWechatOverlayHandle() {
        this.showWechatOverlay = true
      },
      closeWechatOverlayHandle() {
        this.showWechatOverlay = false
      }
    }
  }
</script>

<style scoped>
  .lhsx {
    background: url("./bg.png") no-repeat;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-size: 100% 100%;
    font-size: 14px;
  }

  #form {
    text-align: center;
    position: relative;
    padding: 30px 0;
  }

  input {
    width: 80%;
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    color: #323232;
    font-size: 14px;
    margin-bottom: 25px;
    border: 1px solid #fff;
  }

  .name {
    padding-left: 40px;
    background-image: url("1-1.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .clientMobile {
    padding-left: 40px;
    background-image: url("1-2.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .code {
    padding-left: 40px;
    background-image: url("1-3.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .btn {
    margin: 18px 0;
  }

  .backtop {
    background: url("./1-5.png") center center no-repeat;
    width: 40%;
    height: 40px;
    background-size: 100% 100%;
    border: #fff;
  }

  .wechatImg {
    margin: 20px 0px 10px 0px;
  }

  .topdiv {
    text-align: center;
    padding-bottom: 15px;
  }

  .send {
    background: #ffc500;
    border: #fff;
    font-size: 14px;
    color: #fff;
    width: 115px;
    height: 30px;
    line-height: 30px;
    position: absolute;
    right: 12%;
    bottom: 49%;
  }

  .ystk {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }
  .ystk span:nth-child(1) {
    color: #feef06;
    padding: 0px 5px;
  }
  .ystk span:nth-child(2) {
    color: #dddddd;
  }

  .disable {
    background: #ccc;
    border: #ccc;
  }
  .coloryellow{
    color: #ffeba6;
  }

  .van-overlay {
    display: flex;
    align-items: center;
  }

  .wechatWrapper  {
  }
  .wechatWrapper img {
    display: block;
    margin: 0 auto;
  }
  .wechatWrapper img:nth-child(2) {
    margin-top: 10px;
  }
  
  
</style>


// WEBPACK FOOTER //
// index.vue?444536c1